import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="text-center">
        <h1 className="display-1 fw-bold" style={{ fontSize: '8rem', background: 'var(--primary-gradient)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
          404
        </h1>
        <h2 className="mb-4">Page Not Found</h2>
        <p className="text-muted mb-4">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <button 
          className="btn btn-primary btn-lg"
          onClick={() => navigate('/')}
        >
          <i className="bi bi-house-door me-2"></i>
          Go Home
        </button>
      </div>
    </div>
  );
}
